import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'

export default function PersonSearch({ options, value, onChange, invalid, placeholder }) {
    const selected = (options || []).find((option) => String(option.id) === String(value))
    const [query, setQuery] = useState(selected?.name || '')
    const [open, setOpen] = useState(false)

    useEffect(() => {
        setQuery(selected?.name || '')
    }, [selected?.name])

    const needle = query.trim().toLowerCase()
    const matches = (options || [])
        .filter((option) => !needle || String(option.name).toLowerCase().includes(needle))
        .slice(0, 40)

    return (
        <div className="position-relative">
            <Form.Control
                type="search"
                value={query}
                placeholder={placeholder || 'Buscar agente o empleado'}
                className={invalid ? 'is-invalid' : ''}
                autoComplete="off"
                onChange={(e) => {
                    setQuery(e.target.value)
                    setOpen(true)
                    if (!selected || e.target.value !== selected.name) onChange('')
                }}
                onFocus={() => setOpen(true)}
                onBlur={() => {
                    window.setTimeout(() => {
                        setOpen(false)
                        setQuery(selected?.name || '')
                    }, 150)
                }}
            />
            {open && (
                <div
                    className="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                    style={{ zIndex: 20, maxHeight: 240, overflowY: 'auto' }}
                >
                    {matches.length === 0 ? (
                        <div className="px-3 py-2 text-muted">Sin resultados</div>
                    ) : (
                        matches.map((option) => (
                            <button
                                type="button"
                                key={option.id}
                                className="btn btn-sm text-start w-100 rounded-0"
                                onMouseDown={(e) => {
                                    e.preventDefault()
                                    onChange(String(option.id))
                                    setQuery(option.name)
                                    setOpen(false)
                                }}
                            >
                                {option.name}
                            </button>
                        ))
                    )}
                </div>
            )}
        </div>
    )
}
